import React, { useCallback } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { loadStripe } from "@stripe/stripe-js";
import "../styles/components/EmbeddedCheckoutModal.css";
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout,
} from "@stripe/react-stripe-js";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);
const API_URL = process.env.REACT_APP_API_BASE_URL;

const EmbeddedCheckoutModal = ({
  package: pkg,
  billingCycle,
  onClose,
  domain,
}) => {
  const { isAuthenticated, user, getAccessTokenSilently } = useAuth0();

  const fetchClientSecret = useCallback(async () => {
    try {
      const priceId =
        billingCycle === "monthly"
          ? pkg.stripeMonthlyPriceId
          : pkg.stripeAnnualPriceId;

      const accessToken = await getAccessTokenSilently();
      const userEmail = user?.email;

      const requestBody = {
        priceId,
        packageName: pkg.packname,
        title: pkg.title,
        billing: billingCycle,
        ...(isAuthenticated && user?.sub && { userId: user.sub }),
        ...(domain && { domain }),
      };

      if (isAuthenticated && userEmail) {
        requestBody.customer_email = userEmail;
      }

      const response = await fetch(`${API_URL}/create-checkout-session`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
          "X-User-Email": userEmail || "",
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        throw new Error("Failed to create checkout session");
      }

      const { clientSecret } = await response.json();
      return clientSecret;
    } catch (error) {
      console.error("Error:", error);
      onClose();
      throw error;
    }
  }, [
    pkg,
    billingCycle,
    onClose,
    domain,
    isAuthenticated,
    user,
    getAccessTokenSilently,
  ]);

  return (
    <div className="embedded-checkout-modal" onClick={onClose}>
      <button className="checkout-close-button" onClick={onClose}>
        &times;
      </button>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <EmbeddedCheckoutProvider
          stripe={stripePromise}
          options={{ fetchClientSecret }}
        >
          <EmbeddedCheckout />
        </EmbeddedCheckoutProvider>
      </div>
    </div>
  );
};

export default EmbeddedCheckoutModal;
